import React, { useCallback } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import MyOrderCardV2 from "../../shared/my-order-card-v2";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { Text } from "@cars24/turbo-web/lib/text";
import { withRouter } from "react-router";
import { sendCustomGaEvents } from "../../../tracking";
import { repeatUserOrderSummary } from "./tracking";

const EChallanRecentTransaction = ({ orderData = {}, history }) => {

    const { tokens } = useTokens();

    const handleOnClick = useCallback(async ({ orderNumber }) => {
        await yieldToMain();
        history.push(`/order-summary/${orderNumber}?myOrder=true`);

        sendCustomGaEvents(repeatUserOrderSummary);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div styleName={"styles.recentTransactionWrapper"}>
            <Text fontWeight="semibold" color={tokens.text_default_text_primary} as="h2" size="450">Recent transaction</Text>
            <div styleName={"styles.cardWrapper"}>
                <MyOrderCardV2
                    details={orderData}
                    key={orderData.orderNumber}
                    handleOnClick={handleOnClick}
                    isDesktop
                />
            </div>
        </div>
    );
};

EChallanRecentTransaction.propTypes = {
    orderData: PropTypes.object,
    history: PropTypes.object
};

export default withRouter(EChallanRecentTransaction);
